import { useLayoutEffect } from 'react';

export default function useScrollTopOnMount(xCord = 0, yCord = 0) {
  useLayoutEffect(() => {
    window.scrollTo(xCord, yCord);
  }, []);
}
